// Stove pipe connects the appliance to the chimney. Once the run enters Class A or
// lined masonry it stays there to the termination.
// Takes parts sorted by sequenceOrder, so "after" means later in the flow, not
// later on the canvas.

const STOVE_PIPE = new Set(['pipe-straight', 'elbow-90', 'elbow-45', 'tee']);
const CHIMNEY = new Set(['chimney-straight', 'chimney-30', 'chimney-tee']);
const MASONRY = new Set(['masonry-straight', 'masonry-tee']);

const describe = (componentType) => (MASONRY.has(componentType) ? 'lined masonry' : 'chimney');

export function stovePipeAfterChimneyErrors(orderedItems) {
  let transition = null;

  for (const item of orderedItems || []) {
    const ct = item && item.componentType;
    if (!ct) continue;

    if (!transition && (CHIMNEY.has(ct) || MASONRY.has(ct))) {
      transition = item;
      continue;
    }

    if (transition && STOVE_PIPE.has(ct)) {
      const label = (n) => `Part ${n ?? '?'}`;
      return [
        `${label(item.sequenceOrder)} is stove pipe, but the run has already `
        + `transitioned to ${describe(transition.componentType)} at `
        + `${label(transition.sequenceOrder)}. Stove pipe cannot follow `
        + `${describe(transition.componentType)}.`,
      ];
    }
  }

  return [];
}
